import type { SoundcheckLoanLimits as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';

/**
 * The bounds a new Soundcheck loan must fall within. Read from the internal (VP staff) schema —
 * the AppSchema `SoundcheckLoanLimits` type was removed when the account surface moved.
 */
export type SoundcheckLoanLimits = {
  feePercentageMin: number;
  feePercentageMax: number;
  maxAmount: number;
};

export const fromGql = (item: GQLItem): SoundcheckLoanLimits =>
  take<SoundcheckLoanLimits>(item, 'feePercentageMin', 'feePercentageMax', 'maxAmount');
